import { useSessionContext } from '@contexts';
import { ReactElement } from 'react';

interface GuarantorOptionProps {
    children: ReactElement;
}

const GuarantorOption = ({ children }: GuarantorOptionProps) => {

    const { session } = useSessionContext();

    return (
        <>
            {
                session?.isGuarantor &&
                children
            }
        </>
    );
};

export default GuarantorOption;
